import { Alert, Card, ListGroup } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { LoyaltyTagMultiUpdateResult } from "../domain/LoyaltyTagMultiUpdateResult";
import { loyaltyTagMultiUpdateResultsMessages } from "./LoyaltyTagMultiUpdateResults.messages";

export interface LoyaltyTagMultiUpdateResultsProps {
  result: LoyaltyTagMultiUpdateResult;
}

export function LoyaltyTagMultiUpdateResults({ result }: LoyaltyTagMultiUpdateResultsProps) {
  return (
    <>
      <Alert variant="success" className="m-0">
        <strong>
          <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.fileProcessed} />
        </strong>
      </Alert>

      <Card>
        <Card.Header as="h5">
          <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.header} />
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.created} />:
            {` ${result.created}`}
          </ListGroup.Item>
          <ListGroup.Item>
            <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.deleted} />:
            {` ${result.deleted}`}
          </ListGroup.Item>
          <ListGroup.Item>
            <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.errors} />:
            {` ${result.errors?.length ?? 0}`}
          </ListGroup.Item>
        </ListGroup>
      </Card>

      {result.errors.length > 0 && (
        <>
          <Alert variant="danger" className="m-0">
            <strong>
              <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.alertSomeErrors} />
            </strong>
          </Alert>
          <Card>
            <Card.Header as="h5">
              <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.headerErrors} />
            </Card.Header>
            <div>
              <ListGroup variant="flush">
                {result.errors.map(error => (
                  <ListGroup.Item key={error.ticker}>
                    <div className="flex flex-col gap-2">
                      <span>
                        <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.ticker} />:{" "}
                        {error.ticker}
                      </span>
                      <span>
                        <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.code} />:{" "}
                        {error.code}
                      </span>
                      <span>
                        <FormattedMessage {...loyaltyTagMultiUpdateResultsMessages.message} />:{" "}
                        {error.message}
                      </span>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Card>
        </>
      )}
    </>
  );
}
